import PropTypes from 'prop-types';
import { apiBaseUrl, requestHeaders } from '../index';
import { normalize } from 'normalizr';
import { samplesSchema } from '../normalize';
import { API_RESPONSE_ERROR } from '../constants/actionMessages';
import { requestToken } from '../auth';

const filterTypeToType = str => {
  switch (str) {
    case 'area_functional':
      return 'functional_area';
    case 'area_room':
      return 'room';
    default:
      return str;
  }
};

const sankeyFields = ['timestamp', 'energy'];

export const normalizeResponse = json => {
  const samples = normalize(json.data, [samplesSchema]);

  const meta = {};

  if (json.hasOwnProperty('meta')) {
    meta.sample_interval = json.meta.sample_interval
      ? parseInt(json.meta.sample_interval, 10)
      : null;
  }

  return {
    meta,
    samples: samples.entities.samples
  };
};

export const fetchSamples = async ({
  siteId,
  loggerId,
  queryParams: { from, to, aggregationLevel },
  filter,
  sampleResolution,
  isSankeyData,
  activeEnergyTypes
}) => {
  let apiURL = `/v2/samples`;

  if (isSankeyData) {
    apiURL += `?fields[samples]=${sankeyFields.toString()}`;
  } else {
    apiURL += `?fields[samples]=${[
      'timestamp',
      'energy',
      ...activeEnergyTypes
    ].toString()}`;
  }

  if (from) {
    apiURL += `&filter[from]=${from}`;
  }

  if (to) {
    apiURL += `&filter[to]=${to}`;
  }

  if (loggerId) {
    apiURL += `&filter[data_logger]=${loggerId}`;
  } else {
    apiURL += `&filter[site]=${siteId}`;
  }

  if (filter) {
    apiURL += `&filter[${filterTypeToType(
      filter.filterType
    )}]="${filter.filter}"`;
  }

  if (aggregationLevel) {
    apiURL += `&aggregation_level=${aggregationLevel}`;
  } else {
    apiURL += `&sample_resolution=${sampleResolution}`;
  }

  const nextUrl = path => `${apiBaseUrl}${path}`;

  const gatherResponse = async url => {
    const startDate = new Date();

    let fetchUrl = url;
    let next = true;
    let result = {};

    while (await next) {
      let response = await fetch(nextUrl(fetchUrl), {
        headers: requestHeaders
      });

      if (response.status === 401) {
        requestToken();
      }

      let json = await response.json();

      if (await json.hasOwnProperty('errors')) {
        result = json;
        next = false;
        throw new Error('Error during fetch');
      }

      if (await json.hasOwnProperty('links')) {
        fetchUrl = decodeURIComponent(json.links.next);
      } else {
        next = false;
      }

      if (await result.hasOwnProperty('data')) {
        result.data = [...result.data, ...json.data];
      } else {
        result = json;
      }
    }

    const endDate = new Date();

    if (startDate && endDate) {
      const deltaInSeconds = (endDate - startDate) / 1000;
      console.log(`Samples fetched in ${deltaInSeconds}s`);
    }

    return await result;
  };

  try {
    const d = await gatherResponse(apiURL);
    return await normalizeResponse(d);
  } catch (err) {
    console.log(err);
    return {
      error: {
        code: 500,
        message: API_RESPONSE_ERROR
      }
    };
  }
};

fetchSamples.propTypes = {
  siteId: PropTypes.string.isRequired,
  loggerId: PropTypes.string,
  queryParams: PropTypes.object.isRequired,
  filter: PropTypes.object,
  appWidth: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/helper/api.js